const AddIcon = ({ color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill={color ? color : "rgba(64,64,69,1)"}></path>
    </svg>
  );
};

export default AddIcon;
